// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"072c3f79","313":"596c0e77","425":"d86d5ac3","484":"d3b7b737","980":"49496441"}[chunkId] + ".chunk.js";
};